/*
 * Copyright © 2020-2026 Ocean Galaxy Inc. All Rights Reserved.
 * @Description: 获取批量编辑水印编辑器信息架构实验版本
 */

import { useMemo } from 'react'
import { useLocation } from 'react-router-dom'
import { useAppSelector } from '../../../../app/hooks'
import {
  BATCH_WATERMARK_EDITOR_CLARITY_CONFIG_KEY,
  BATCH_WATERMARK_EDITOR_CLARITY_QUERY_KEY,
  resolveEditorClarityVariant
} from '../utils/batchWatermarkEditorClarityExperiment'
import type { BatchWatermarkEditorClarityVariant } from '../utils/batchWatermarkEditorClarityExperiment'
import { parseBatchWatermarkExperimentRolloutPercentage } from '../utils/batchWatermarkExperimentConfig'

/** 返回当前团队稳定命中的编辑器信息架构实验版本。 */
export const useBatchWatermarkEditorClarityVariant =
  (): BatchWatermarkEditorClarityVariant => {
    const teamShortId = useAppSelector((state) => state.group.invite_id)
    const remoteConfigValue: unknown = useAppSelector(
      (state) => state.main.config?.[BATCH_WATERMARK_EDITOR_CLARITY_CONFIG_KEY]
    )
    const { search } = useLocation()

    return useMemo(() => {
      const overrideVariant = new URLSearchParams(search).get(
        BATCH_WATERMARK_EDITOR_CLARITY_QUERY_KEY
      )
      const isProductionBuild = __BUILD_ENV__ === 'prod'
      const rolloutPercentage = parseBatchWatermarkExperimentRolloutPercentage(
        remoteConfigValue,
        isProductionBuild ? 'production' : 'test'
      )

      return resolveEditorClarityVariant(teamShortId, {
        rolloutPercentage,
        overrideVariant,
        allowOverride: !isProductionBuild
      })
    }, [remoteConfigValue, search, teamShortId])
  }
